import '../node_modules/bootstrap/scss/bootstrap.scss' 


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import { Link } from "react-router-dom";

import Nav from './Nav'

function App() {
  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-2">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white pb-5 t-76 title-shade">Pisos, pavimentos y obras civiles</h3>    
                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/pisos/coopermix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Coppermix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/powermix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Powermix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/hormigonfibra" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigón con fibra <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/continua" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Continua  <span className="chevron">></span></p>
                      </div>
                      </Link>
                      
                    </div>                    

                  </div>


                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/pisos/pisomix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Pisomix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/viamix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Viamix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/melon3d" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Melón 3D <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/terminacionhelicoptero" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Terminación helicóptero  <span className="chevron">></span></p>
                      </div>
                      </Link>
                      
                    </div>                    

                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/pisos/durenza" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Durenza <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/drencret" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Drencret <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/shotcrete" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Shotcrete <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/hormigonporoso" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Hormigón poroso  <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/pisos/fasttrack" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Fast Track  <span className="chevron">></span></p>
                      </div>                      
                      </Link>
                      
                    </div>                    

                  </div>                                    

                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
